import React from 'react'
import styled from 'styled-components'

export interface FlexContainerProps {
    direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse'
    paddingX?: string
    paddingY?: string
    align?: string
    justify?: string
    spacing?: string
}

const FlexContainer: React.FC<FlexContainerProps> = props => {
    return (
        <Container
            direction={props.direction}
            paddingX={props.paddingX}
            paddingY={props.paddingY}
            align={props.align}
            justify={props.justify}
            spacing={props.spacing}
        >
            {props.children}
        </Container>
    )
}

const Container = styled.div<FlexContainerProps>`
    ${({ direction, paddingX, paddingY, align, justify, spacing }) => {
        let css = `
            display: flex;
            flex-direction: ${direction || 'row'};
            align-items : ${align || 'center'};
            justify-content : ${justify || 'center'};
            padding-left : ${paddingX ? paddingX : 0};
            padding-right : ${paddingX ? paddingX : 0};
            padding-top : ${paddingY ? paddingY : 0};
            padding-bottom : ${paddingY ? paddingY : 0};
            `
        if (spacing) {
            css += `
                    & > * {
                        margin-left: ${spacing};
                        margin-right: ${spacing};
                    }
                `
        }

        return css
    }}
`
export default FlexContainer
